import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { superAdminService } from '../services/super-admin.service';
import type { SuperAdmin } from '../types/super-admin.types';

export function useSuperAdminStatus(): {
  deactivate: UseMutateFunction<SuperAdmin, Error, string>;
  isDeactivating: boolean;
  activate: UseMutateFunction<SuperAdmin, Error, string>;
  isActivating: boolean;
  sendPasswordReset: UseMutateFunction<void, Error, string>;
  isSendingReset: boolean;
} {
  const queryClient = useQueryClient();

  const deactivateMutation = useMutation({
    mutationFn: (userId: string) => superAdminService.deactivateSuperAdmin(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admins'] });
    },
  });

  const activateMutation = useMutation({
    mutationFn: (userId: string) => superAdminService.activateSuperAdmin(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admins'] });
    },
  });

  const sendPasswordResetMutation = useMutation({
    mutationFn: (userId: string) => superAdminService.sendPasswordReset(userId),
  });

  return {
    deactivate: deactivateMutation.mutate,
    isDeactivating: deactivateMutation.isPending,
    activate: activateMutation.mutate,
    isActivating: activateMutation.isPending,
    sendPasswordReset: sendPasswordResetMutation.mutate,
    isSendingReset: sendPasswordResetMutation.isPending,
  };
}
